import { GESTION_OPERATIVA_OPEN_COMMENT_DRAWER } from './constants'

export const openCommentDrawer = mode => {
  return dispatch => {
    dispatch({
      type: GESTION_OPERATIVA_OPEN_COMMENT_DRAWER,
      data: mode
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_OPEN_COMMENT_DRAWER) {
      return {
        ...state,
        commentDrawerOpen: true,
        commentDrawerMode: action.data,
        commentDrawerText: state.sale.observation
      }
  }
  else {
    return state
  }      
}